var $ = require('jquery');
var overlayPanelTpl = require('../templates/partials/overlayPanelTpl.hbs');

/**
 * Wrapper object that server as a container to display selected nearby attraction details
 * @constructor
 * @param {Object} markerGroup - object that controls the markers
 * @param {Object} $overlayPanel - jQuery wrapped overlay panel element
 */
function OverlayPanel(markerGroup, $overlayPanel) {
  this.markerGroup = markerGroup;
  this.$overlayPanel = $overlayPanel;
  this.bindEvent();
}

/**
 * Show nearby attraction details in overlay panel
 * @param {Object} nearByDetails - nearby attraction details
 * @return {void}
 */
OverlayPanel.prototype.show = function (nearByDetails) {
  this.$overlayPanel.html(overlayPanelTpl(nearByDetails));
  this.$overlayPanel.fadeIn('fast');
};

/**
 * Hide overlay panel
 * @return {void}
 */
OverlayPanel.prototype.hide = function () {
  var _self = this;
  this.$overlayPanel.fadeOut('fast', function () {
    _self.markerGroup.toggleActiveMarker();
    _self.$overlayPanel.empty();
  });
};

/**
 * Attach click listeners to close overlay panel
 * @return {void}
 */
OverlayPanel.prototype.bindEvent = function () {
  var _self = this;
  _self.$overlayPanel.on("click", function (event) {
    if($(event.target).hasClass('js-overlay-panel-close')){
      _self.markerGroup.toggleActiveMarker();
    }
  });
};

module.exports = OverlayPanel;